import styled from "styled-components";

export const FormWrapper = styled.div`
  .MuiFormControl-root {
    width: 100%;
    margin: 10px 0;
  }
`;
